var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 991"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 990",
    x: 0.5,
    y: 4.39478,
    width: 7.10526,
    height: 7.10526,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M4.05273 2.73684V1H11.0001V7.94737H9.26326",
    stroke: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.74027adddfc26267ecb0766429d00e01.svg";
export { ForwardRef as ReactComponent };